import React from 'react'
import { CTALink } from '../../elements/CTALink'
import { ImageOrAutoplayVideo } from '../../elements/ImageOrAutoplayVideo'
import { CTATheme, mq } from '../../utils'
import { FeatureSpotlightBase } from '../FeatureSpotlightBase'
import { IProps } from './index'

export class FeatureSpotlightProductDemo extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props)
    this.renderMedia = this.renderMedia.bind(this)
  }
  renderMedia() {
    const { productImgRef, productVideo, productVideoWebm } = this.props
    return (
      <ImageOrAutoplayVideo
        imageRef={productImgRef}
        video={productVideo}
        videoWebm={productVideoWebm}
      />
    )
  }
  render() {
    const { productIcon, productCTA, cta } = this.props
    return (
      <FeatureSpotlightBase {...this.props} renderMedia={this.renderMedia}>
        <div className="feature-spotlight__demo-cta">
          <img src={productIcon} alt="" className="feature-spotlight__demo-cta-icon" />
          <span className="feature-spotlight__cta">
            <CTALink {...productCTA} bgColor={CTATheme.LinkOnlyBlack} />
          </span>
          <style jsx>
            {`
              .feature-spotlight__demo-cta {
                display: block;
                margin: ${cta ? '1rem' : '1.25rem'} 0 0 0;
              }

              .feature-spotlight__demo-cta-icon {
                width: 24px;
                margin-right: 12px;
                vertical-align: middle;
              }

              .feature-spotlight__cta {
                display: inline-block;
                vertical-align: middle;
              }

              @media (${mq.desktop}) {
                .feature-spotlight__demo-cta {
                  display: inline-block;
                  margin-top: 0;
                }
              }
            `}
          </style>
        </div>
      </FeatureSpotlightBase>
    )
  }
}
